<template lang="pug">
div
  .modal.is-active(v-if="showModalArchivo")
    .modal-background(@click="cerrarArchivo")

    .modal-card.modal-archivo

      header.modal-card-head
        p.modal-card-title
          i.fa.fa-paperclip
          span Archivo adjunto

        button.delete(
          @click="cerrarArchivo"
        )

      section.modal-card-body

        img.preview-image(
          v-if="archivoSeleccionado && !esPdf(archivoSeleccionado)"
          :src="archivoSeleccionado"
        )

        iframe.preview-pdf(
          v-if="archivoSeleccionado && esPdf(archivoSeleccionado)"
          :src="archivoSeleccionado"
        )

      footer.modal-card-foot
        button.button(
          @click="cerrarArchivo"
        )
          | Cerrar
  .section-news
    .news-header
      div
        h2 Últimas noticias
        p Mantente informado de comunicados, capacitaciones y novedades importantes.

    .news-scroll(
      ref="newsScroll"
      @scroll="onNewsScroll"
    )
      .news-grid

        .news-card(
          v-for="item in noticiasVisibles"
          :key="item.id"
        )

          .news-card-header
            .news-file-type(v-if="item.foto")
              i.fa(
                :class="esPdf(item.foto) ? 'fa-file-pdf-o' : 'fa-image'"
              )
              span {{ esPdf(item.foto) ? 'PDF' : 'Imagen' }}

            span.news-badge(
              :class="item.tipo"
            )
              | {{ item.tipo }}

          .news-content
            h3 {{ item.titulo }}

            p.news-description
              | {{ item.descripcion }}

          .news-actions
            button.btn-view-file(
              v-if="item.foto"
              @click="abrirArchivo(item)"
            )
              i.fa.fa-eye
              span Ver archivo

            span.no-file(v-else)
              i.fa.fa-paperclip
              | Sin archivo adjunto

      .news-loading(v-if="cargandoNoticias")
        i.fa.fa-spinner.fa-spin
        span Cargando noticias...

      .news-end(
        v-if="noMore && noticiasVisibles.length"
      )
        | No hay más noticias
</template>
<script>
import { apiGet, notify }  from '../../../util/general'
// import moment from 'moment';
export default {
  name: 'MisCursos',
  data () {
    return {
      lista                                 : [],
      noticias: [],
      noticiasVisibles: [],

      paginaNoticias: 1,
      limiteNoticias: 6,

      cargandoNoticias: false,
      hayMasNoticias: true,

      showModalArchivo: false,
      archivoSeleccionado: null,
      isloading         : false,
      isScroll          : false,
      numeroRecnum      : 0,
      disabledScrollExcecute  : true,
      noMore                  : false
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    esPdf (url) {
      if (!url) return false;

      return url
        .split('?')[0]
        .toLowerCase()
        .endsWith('.pdf');
    },

    abrirArchivo (item) {
      this.archivoSeleccionado = item.foto;
      this.showModalArchivo = true;
    },

    cerrarArchivo () {
      this.showModalArchivo = false;
      this.archivoSeleccionado = null;
    },

    onNewsScroll () {
      const contenedor = this.$refs.newsScroll

      if (!contenedor) return

      // Evita llamadas mientras ya se está consultando
      if (this.cargandoNoticias) return

      // Ya no existen más registros
      if (this.noMore) return

      const distanciaFinal =
        contenedor.scrollHeight -
        contenedor.scrollTop -
        contenedor.clientHeight

      if (distanciaFinal <= 100) {
        this.isScroll = true
        this.fetch()
      }
    },

    fetch () {
      var vm               = this
      if (vm.cargandoNoticias) {
        return
      }

      vm.cargandoNoticias         = true

      if (!vm.isScroll) {
        vm.noticiasVisibles = []
        vm.numeroRecnum = 0
        vm.noMore = false
      }

      vm.disabledScrollExcecute = true
      vm.noMore                 = false

      var url         = `/administrador-noticias/obtener`
      var obj = {
        estado       : 1,
        isTodo       : true,
        numeroRecnum : vm.numeroRecnum
      }
      apiGet(vm, url, obj, function (data) {
        const nuevasNoticias = data.lista || []
        const idsExistentes = new Set(
          vm.noticiasVisibles.map(item => item.id)
        )
        const noticiasSinDuplicar = nuevasNoticias.filter(
          item => !idsExistentes.has(item.id)
        )
        vm.noticiasVisibles.push(...noticiasSinDuplicar)

        if (data.numeroRecnum !== undefined &&
            data.numeroRecnum !== null) {
          vm.numeroRecnum = data.numeroRecnum
        }

        vm.noMore = Boolean(data.noMore)
      }, function (err) {
        vm.disabledScrollExcecute = true
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isScroll   = false
        vm.cargandoNoticias  = false
      })
    }
  }
}
</script>
<style scoped>
.section-news {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 16px;
  overflow: hidden;
}

.news-header {
  padding: 22px 24px 15px;
}

.news-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #27334d;
}

.news-header p {
  margin-top: 6px;
  font-size: 14px;
  color: #7c8aa0;
}


/* SCROLL DE LAS NOTICIAS */

.news-scroll {
  max-height: 480px;
  overflow-y: auto;
  padding: 5px 20px 20px;
}


/* scrollbar discreto */

.news-scroll::-webkit-scrollbar {
  width: 7px;
}

.news-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.news-scroll::-webkit-scrollbar-thumb {
  background: #d7dce5;
  border-radius: 10px;
}


.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}


/* CARD */

.news-card {
  min-height: 210px;
  padding: 18px;
  border: 1px solid #e7eaf1;
  border-radius: 14px;
  background: #fff;

  display: flex;
  flex-direction: column;

  transition:
    transform .2s ease,
    box-shadow .2s ease;
}


.news-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, .07);
}


.news-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
}


.news-file-type {
  display: flex;
  align-items: center;
  gap: 7px;

  color: #7b8798;
  font-size: 12px;
}


.news-file-type i {
  font-size: 17px;
}


/* ESTADOS */

.news-badge {
  padding: 5px 11px;
  border-radius: 20px;

  font-size: 11px;
  font-weight: 600;
}


.news-badge.Nuevo {
  background: #def7e8;
  color: #168348;
}


.news-badge.Actualizado {
  background: #fbff00;
  color: #000000;
}


/* CONTENIDO */

.news-content {
  flex: 1;
  padding: 18px 2px;
}


.news-content h3 {
  margin: 0 0 10px;

  color: #27334d;
  font-size: 16px;
  font-weight: 700;
}


.news-description {
  color: #77849a;
  font-size: 13px;
  line-height: 1.6;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  overflow: hidden;
}


/* BOTÓN */

.news-actions {
  border-top: 1px solid #eef0f5;
  padding-top: 13px;
}


.btn-view-file {
  width: 100%;

  border: 0;
  border-radius: 9px;

  background: #f3f4fc;
  color: #5b5ce2;

  padding: 10px;

  font-size: 13px;
  font-weight: 600;

  cursor: pointer;
}


.btn-view-file i {
  margin-right: 7px;
}


.btn-view-file:hover {
  background: #e9eafd;
}


.no-file {
  display: block;
  text-align: center;

  color: #a2abba;
  font-size: 12px;

  padding: 10px;
}


.no-file i {
  margin-right: 6px;
}


/* LOAD MORE */

.news-loading,
.news-end {
  padding: 20px;
  text-align: center;
  color: #8b96a8;
  font-size: 13px;
}


.news-loading i {
  margin-right: 7px;
}


/* MODAL */

.modal-archivo {
  width: 850px;
}


.preview-image {
  display: block;

  max-width: 100%;
  max-height: 650px;

  margin: auto;

  object-fit: contain;
}


.preview-pdf {
  width: 100%;
  height: 650px;

  border: none;
}


/* RESPONSIVE */

@media (max-width: 1000px) {
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}


@media (max-width: 650px) {
  .news-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// c_noticias.vue?10d58e82